import { mapActions, mapState } from "vuex";

const onboardingCompletedGuard = {
    computed: {
        ...mapState("onboarding", ["onboardingFlow"])
    },

    mounted() {
        this.$_onboardingGuardPageshow = async (event) => {
            if (!event.persisted) return;
            try {
                await this.getOnboardingStatus();
            } catch {
                return;
            }
            this.redirectIfOnboardingCompleted();
        };
        window.addEventListener("pageshow", this.$_onboardingGuardPageshow);
    },

    beforeDestroy() {
        window.removeEventListener("pageshow", this.$_onboardingGuardPageshow);
    },

    methods: {
        ...mapActions("onboarding", ["getOnboardingStatus"]),
        redirectIfOnboardingCompleted(flow = this.onboardingFlow) {
            if (flow && flow.status === "completed" && !flow.nextStep) {
                this.$router.replace("/app");
                return true;
            }
            return false;
        }
    }
};

export default onboardingCompletedGuard;
